<div style="margin-top:30px;">
    {{miFooterData.invoiceCommentsFromUser}}
</div>

<div style="margin-top:30px;margin-left:20%;margin-right:20%">
    <hr />
</div>

<div style="margin-top:20px;">

    <div class="row">
        <div class="col-12 text-center">
            {{miFooterData.globalFooterVerbiage}}
        </div>
    </div>

<div class="row" style="margin-top:20px;">
    <div class="col-12 text-center">
        <em>
        By valuing our employees, listening to our clients, and operating under the ideals of moral integrity, quality, and
            accountability, we will lead the parking industry in service and financial results for our clients. 
        </em>
    </div>
</div>

<div class="row" style="margin-top:10px;">
      <div class="col-12" style="height:50px;background-color: #002F87;border: 1px black solid;">
        <div style="margin-top:10px;">
            <span style="font-size:21px;color:white;"><strong><em>{{miFooterData.companyTagLineVerbiage}}&trade;</em></strong></span>
        </div>
    </div>
    <!-- <div class="col-6 text-end" style="height:50px;background-color: #002F87;border: 1px black solid;">
        <div style="margin-top:10px;">
            <span style="font-size:28px;color:white"><strong>Invoice Details</strong></span>
        </div>
    </div> -->
</div>

<div class="row" style="margin-top:10px;">
    <div class="col-12 text-center">
      <span>See our privacy policy here:  https://aceparking.com/privacy</span>
    </div>
</div>

</div>